export default "__VITE_ASSET__DAGTOwcq__"